// OurValues.js
import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Heart, Award, Handshake } from 'lucide-react';

const OurValues = () => {
  const values = [
    {
      icon: Shield,
      title: 'Integrity',
      description: 'Sometimes the truthful answer is that a route will not work for someone. We say so.',
      color: 'blue'
    },
    {
      icon: Heart,
      title: 'Responsibility',
      description: 'Relocating for a degree or a job reshapes a life, and we handle that weight carefully.',
      color: 'red'
    },
    {
      icon: Award,
      title: 'Professionalism',
      description: 'What we do is written down and repeatable, so nothing rests on memory or luck.',
      color: 'green'
    },
    {
      icon: Handshake,
      title: 'Respect',
      description: 'Applicants, universities and employers are all dealt with courteously, without exception.',
      color: 'purple'
    }
  ];

  const getColorClasses = (color) => {
    const colors = {
      blue: 'border-t-blue-500',
      red: 'border-t-red-500',
      green: 'border-t-green-500',
      purple: 'border-t-purple-500'
    };
    return colors[color] || 'border-t-blue-500';
  };

  return (
    <section className="py-16 bg-surface">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl md:text-4xl font-semibold text-primary mb-4">
            Our Values
          </h2>
        </motion.div>

        {/* Values Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {values.map((value, index) => {
            const Icon = value.icon;
            return (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className={`bg-white p-6 border-t-2 ${getColorClasses(value.color)} hover:shadow-lg transition-shadow`}
              >
                <Icon size={32} className="text-gray-700 mb-4" />
                
                <h3 className="text-lg font-semibold text-primary mb-3 leading-tight">
                  {value.title}
                </h3>
                
                <p className="text-gray-600 text-sm font-light leading-relaxed">
                  {value.description}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default OurValues;
